module.exports = __webpack_public_path__ + "img/160.092e9562.jpg";